import React, { type MouseEventHandler } from 'react';

import { Button } from '@shared/components/bootstrap';

import {
  useConfirmation,
  Dialog as ConfirmationDialog,
  Response as ConfirmationResponse,
} from '@admin/components/confirmation';
import { client } from '@admin/libraries/apollo';
import { Status, useRedirectDestroyMutation, type Redirect } from '@admin/schema';

export const RedirectDestroyButton: React.FC<{
  redirect: Pick<Redirect, 'id' | 'slugs' | 'targetURL'>;
  onDelete(): void;
}> = ({ redirect, onDelete }) => {
  const [execute, { loading }] = useRedirectDestroyMutation({
    client,
    variables: { id: redirect.id },
  });
  const { confirmation, confirm } = useConfirmation();

  const onClick: MouseEventHandler<HTMLButtonElement> = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (loading) return;

    const confirmed = await confirm({
      title: 'Are you sure you want to delete this redirect?',
      description: 'This action cannot be undone.',
    });
    if (confirmed !== ConfirmationResponse.Confirm) return;

    const response = await execute({
      variables: { id: redirect.id },
    });

    if (response.data?.redirectDestroy.status === Status.Ok) onDelete();
  };

  return (
    <>
      {confirmation && <ConfirmationDialog confirmation={confirmation} />}
      <Button type="button" kind="danger" onClick={onClick} loading={loading}>
        Delete
      </Button>
    </>
  );
};
